import { Navigate, Route } from "react-router-dom";

import { PORTAL_USER_TYPE } from "@/app/models";
import {
  ADMIN_ROUTES,
  BASE_ROUTE,
  PortalRoutesWrapper,
  ROUTES,
} from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { CoachingLab, CreateSession, EditSession } from "../screens";

const getPartialRoute = (route: string) => {
  return route.replace(ADMIN_ROUTES.COACHING.BASE, "");
};

export const AdminCoachingRouter = () => {
  const userType = usePortalUserStore((state) => state.portalUser?.type);

  if (userType !== PORTAL_USER_TYPE.ADMIN) {
    return <Navigate to={ROUTES.BASE} />;
  }

  return (
    <PortalRoutesWrapper>
      <Route index element={<CoachingLab />} />
      <Route
        path={getPartialRoute(ADMIN_ROUTES.COACHING.CREATE_SESSION)}
        element={<CreateSession />}
      />
      <Route
        path={getPartialRoute(ADMIN_ROUTES.COACHING.EDIT_SESSION)}
        element={<EditSession />}
      />

      <Route path="*" element={<Navigate to={BASE_ROUTE.COACHING} />} />
    </PortalRoutesWrapper>
  );
};
